import { render, staticRenderFns } from "./CertificationsCard.vue?vue&type=template&id=152c61b0&scoped=true&"
import script from "./CertificationsCard.vue?vue&type=script&lang=js&"
export * from "./CertificationsCard.vue?vue&type=script&lang=js&"
import style0 from "./CertificationsCard.vue?vue&type=style&index=0&id=152c61b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152c61b0",
  null
  
)

export default component.exports